export default {
  // ========== Encabezado ==========
  pia: "PIA",
  suitcase: "Maleta",
  didactic: "Didáctica",
  subjectImplementationProgram: "Programa de Implementación de Asignatura",

  // ========== Sección 1: Antecedentes Generales ==========
  generalBackground: "Antecedentes Generales",
  careerName: "Nombre Carrera/s",
  studyPlans: "Planes de Estudio",
  totalHours: "Horas Totales",
  programmingWeeks: "N° de Semanas de Programación",
  inPersonDirectTeaching: "Docencia Dirigida Presencial",
  nonInPersonDirectTeaching: "Docencia Dirigida No Presencial",
  pedagogicalHours: "Horas Pedagógicas",
  environment: "Ambiente",
  suggestedStudentCount: "N° de Estudiantes Sugerido",
  autonomousWorkChronologicalHours: "Horas Cronológicas de Trabajo Autónomo",
  assistantshipHoursCount: "N° Horas Ayudantía",
  prerequisites: "Prerrequisitos",

  // ========== Indicaciones ==========
  noGuidelines: "No hay Orientaciones.",
  otherProgrammingIndications: "Otras indicaciones para la programación",

  // ========== Sección 2: Descripción de la Asignatura ==========
  subjectDescription: "Descripción de la Asignatura",
  noDescriptionForEntity: "No hay descripción para {entity}.",
  noEntityForSubject: "No hay {entity1} para {entity2}.",

  // ========== Competencias y Resultados de Aprendizaje ==========
  learningResults: "Resultados de Aprendizaje",

  // ========== Sección 3: Síntesis de la Ruta de Aprendizaje ==========
  learningRouteSynthesis: "Síntesis de la Ruta de Aprendizaje",
  learningExperience: "Experiencia de Aprendizaje",
  learningEnvironment: "Ambiente de Aprendizaje",
  evaluationType: "Tipo de Evaluación",
  weighting: "Ponderación",
  finalWeighting: "Ponderación Final",
  exam: "Examen",
  total: "Total",
  teacherNote: "Nota: El/la docente puede agregar evaluaciones parciales o controles adicionales a las señaladas en este documento. Sin embargo, debe asegurarse que las evaluaciones mantengan la ponderación asociada a cada {entity}.",

  // ========== Sección 4: Evaluación Final Transversal ==========
  transversalFinalEvaluation: "Evaluación Final Transversal",
  applicationCharacteristics: "Características de la Aplicación",
  avaReleaseWeek: "Semana Liberación en AVA",
  etDevelopmentTime: "Tiempo para el desarrollo o aplicación del ET",
  workType: "Tipo de trabajo (individual o grupal)",
  evaluator: "Evaluador/a",
  etApplicationPlace: "Lugar de aplicación del ET",

  // ========== Sección 5: Docentes ==========
  teachers: "Docente(s)",
  teacherCount: "Número de Docentes",
  teacherProfile: "Perfil Docente {number}",
  theoryHours: "Horas teóricas",
  practicalHours: "Horas prácticas",
  nonInPersonHours: "Horas no presenciales",
  specialization: "Especialización",
  workExperienceYears: "Años de experiencia laboral en el área",
  training: "Formación",
  workExperienceValidity: "Vigencia Experiencia Laboral",
  observations: "Observaciones",

  // ========== Sección 6: Ayudante ==========
  assistant: "Ayudante",
  assistantProfile: "Perfil Ayudante {number}",
  assistantRole: "Rol del Ayudante",

  // ========== Sección 7: Recursos para la Implementación ==========
  implementationResources: "Recursos para la Implementación",
  mandatoryBibliography: "Bibliografía Obligatoria",
  learningEnvironmentResourcesFer: "Recursos por {entity} (referencia Ficha FER)",
}
